import { yesterday } from './time';

export const preprocessSyntheticData = data => {
// Processes synthetic status data to handle special cases for yesterday's data and filtering Tiktok failures
  const processedData = { ...data };

  // TODO: remove filtering of Tiktok synthetic once the data is reliable
  // Filter out Tiktok and yesterday's failures
  processedData.failures = data.failures.filter(failure => {
    if (failure.platform === 'tiktok') return false;

    const filteredDates = failure.dates.filter(date => !date.startsWith(yesterday));
    return filteredDates.length > 0;
  }).map(failure => ({
    ...failure,
    dates: failure.dates.filter(date => !date.startsWith(yesterday)),
  }));

  // Update successes
  processedData.successes = data.successes.map(success => {
    const hasYesterdayFailure = data.failures.some(
      failure => failure.platform === success.platform && failure.dates.some(date => date.startsWith(yesterday)),
    );

    if (hasYesterdayFailure && !success.dates.some(date => date.startsWith(yesterday))) {
      return {
        ...success,
        dates: [...success.dates, `${yesterday} 00:00:00`],
      };
    }
    return success;
  });

  return processedData;
};
